import { render, staticRenderFns } from "./ChoiceMoreRank.vue?vue&type=template&id=1bfae73e&scoped=true"
import script from "./ChoiceMoreRank.vue?vue&type=script&lang=js"
export * from "./ChoiceMoreRank.vue?vue&type=script&lang=js"
import style0 from "./ChoiceMoreRank.vue?vue&type=style&index=0&id=1bfae73e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfae73e",
  null
  
)

export default component.exports